(() => {
  if (customElements.get('bc-migration-network')) return;
  class MigrationNetwork extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.elapsed = 0;
      this.lastTime = null;
      const trails = this.querySelectorAll('[data-migration-trail]');
      const gradients = this.querySelectorAll('[data-migration-gradient]');
      const dots = this.querySelectorAll('[data-migration-packet]');
      this.connections = [...this.querySelectorAll('[data-migration-track]')].map((line, index) => ({
        line, trail:trails[index], gradient:gradients[index], dot:dots[index],
        length:line.getTotalLength(), delay:index * 550
      }));
      this.step = this.step.bind(this);
      const signal = this.abort.signal;
      document.addEventListener('visibilitychange', () => this.sync(), { signal });
      this.reduced.addEventListener('change', () => this.sync(), { signal });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries.some(entry => entry.isIntersecting);
        this.sync();
      }, { threshold:.05 });
      this.observer.observe(this);
    }
    sync() {
      if (!this.visible || document.hidden || this.reduced.matches) {
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.lastTime = null;
        this.connections.forEach(({ trail, dot }) => { trail.style.opacity = dot.style.opacity = '0'; });
      } else if (!this.frame) this.frame = requestAnimationFrame(this.step);
    }
    step(time) {
      if (this.lastTime !== null) this.elapsed += Math.min(80, time - this.lastTime);
      this.lastTime = time;
      this.connections.forEach(({ line, trail, gradient, dot, length, delay }) => {
        const travel = this.elapsed - delay;
        const age = travel % 6200;
        if (travel < 0 || age >= 2600 || length <= 0) {
          trail.style.opacity = dot.style.opacity = '0';
          return;
        }
        // Same moving gradient, packet layering and timing as the home growth engine.
        const progress = age / 2600;
        const tailStart = Math.max(0, progress - .18);
        const alpha = Math.min(age / 250, (2600 - age) / 250, 1);
        const point = line.getPointAtLength(progress * length);
        const tail = line.getPointAtLength(tailStart * length);
        gradient.setAttribute('x1', tail.x); gradient.setAttribute('y1', tail.y);
        gradient.setAttribute('x2', point.x); gradient.setAttribute('y2', point.y);
        trail.style.strokeDasharray = `${Math.min(.18, progress)} 1`;
        trail.style.strokeDashoffset = String(-tailStart);
        trail.style.opacity = String(alpha * .5);
        dot.setAttribute('cx', point.x); dot.setAttribute('cy', point.y);
        dot.style.opacity = String(alpha * .8);
      });
      this.frame = requestAnimationFrame(this.step);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  }
  customElements.define('bc-migration-network', MigrationNetwork);
})();
